import { useState } from 'react';
import axios from 'axios';

const TIPI = [
  { key: 'imprese',         label: 'Imprese',           desc: 'Anagrafica imprese' },
  { key: 'legali',          label: 'Legali Rappresentanti', desc: 'Dati legali rappresentanti' },
  { key: 'direttori',       label: 'Direttori Tecnici', desc: 'Dati direttori tecnici' },
  { key: 'lavori',          label: 'Lavori',             desc: 'Elenco lavori (certificati)' },
  { key: 'cifra-affari',    label: 'Cifra d\'Affari',   desc: 'Volume affari per anno (colonne Anno1..Anno15)' },
  { key: 'ammortamenti',    label: 'Ammortamenti',       desc: 'Ammortamenti per anno (colonne Anno1..Anno15)' },
  { key: 'costo-personale', label: 'Costo Personale',   desc: 'Costo personale per anno (colonne Anno1..Anno15)' },
];

function BlockImport({ tipo }) {
  const [file, setFile] = useState(null);
  const [anteprima, setAnteprima] = useState(null);
  const [risultato, setRisultato] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errore, setErrore] = useState('');

  async function caricaAnteprima(f) {
    setFile(f);
    setRisultato(null);
    setErrore('');
    setAnteprima(null);
    const fd = new FormData();
    fd.append('file', f);
    try {
      const r = await axios.post('/api/importazione/anteprima', fd);
      setAnteprima(r.data);
    } catch {
      setErrore('Impossibile leggere il file.');
    }
  }

  async function importa() {
    if (!file) return;
    setLoading(true);
    setErrore('');
    setRisultato(null);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const r = await axios.post(`/api/importazione/${tipo.key}`, fd);
      setRisultato(r.data);
    } catch (err) {
      setErrore(err.response?.data?.error || 'Errore durante l\'importazione');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="bg-white rounded-xl shadow p-5">
      <h3 className="font-bold text-[#1A3A5C] text-base">{tipo.label}</h3>
      <p className="text-xs text-gray-500 mb-3">{tipo.desc}</p>

      <div className="flex items-center gap-3 flex-wrap">
        <label className="cursor-pointer">
          <span className="border border-gray-300 rounded-lg px-4 py-1.5 text-sm text-gray-600 hover:bg-gray-50 transition">
            {file ? file.name : 'Scegli file Excel…'}
          </span>
          <input
            type="file"
            accept=".xlsx,.xls"
            className="hidden"
            onChange={e => e.target.files[0] && caricaAnteprima(e.target.files[0])}
          />
        </label>

        {anteprima && (
          <button
            onClick={importa}
            disabled={loading}
            className="bg-[#1A3A5C] text-white px-5 py-1.5 rounded-lg text-sm font-medium hover:bg-[#2E6096] transition disabled:opacity-50"
          >
            {loading ? 'Importazione...' : `Importa (${anteprima.totale_righe} righe)`}
          </button>
        )}
      </div>

      {/* Anteprima colonne */}
      {anteprima && !risultato && (
        <div className="mt-3">
          <p className="text-xs text-gray-500 mb-1">
            Colonne rilevate ({anteprima.colonne.length}):
          </p>
          <div className="flex flex-wrap gap-1">
            {anteprima.colonne.map(c => (
              <span key={c} className="bg-[#EEF4FB] text-[#1A3A5C] text-xs px-2 py-0.5 rounded">
                {c}
              </span>
            ))}
          </div>
        </div>
      )}

      {errore && <p className="text-red-600 text-sm mt-3">{errore}</p>}

      {/* Risultato importazione */}
      {risultato && (
        <div className="mt-3 space-y-2">
          <p className="text-green-700 text-sm font-medium">
            ✓ Importati: {risultato.importate} record
          </p>
          {risultato.errori?.length > 0 && (
            <div>
              <p className="text-red-600 text-xs font-medium mb-1">
                {risultato.errori.length} errori:
              </p>
              <div className="bg-red-50 rounded-lg p-3 max-h-40 overflow-y-auto">
                {risultato.errori.map((e, i) => (
                  <p key={i} className="text-xs text-red-700">{e}</p>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function Importazione() {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-[#1A3A5C]">Importazione dati da Access</h1>
          <p className="text-sm text-gray-500 mt-1">
            Carica i file Excel esportati da Access. L'ordine consigliato è quello in elenco.
          </p>
        </div>
      </div>

      <div className="bg-[#EEF4FB] rounded-xl p-4 mb-6 text-sm text-[#1A3A5C]">
        <p className="font-semibold mb-1">Note importazione:</p>
        <ul className="list-disc list-inside space-y-0.5 text-xs text-gray-600">
          <li>Importa prima le <strong>Imprese</strong>, poi tutti gli altri file (usano il nome impresa per il collegamento)</li>
          <li>Valori in lire (anno ≤ 2001 e valore &gt; 500.000) vengono convertiti automaticamente in euro</li>
          <li>Date nei formati gg/mm/aaaa o gg.mm.aa vengono convertite automaticamente</li>
          <li>I dati economici orizzontali (Anno1..Anno15) vengono convertiti in righe verticali</li>
        </ul>
      </div>

      <div className="space-y-4">
        {TIPI.map(t => <BlockImport key={t.key} tipo={t} />)}
      </div>
    </div>
  );
}
